import { AxiosResponse } from 'axios';
import qs from 'qs';
import {
  BlogHomepageCardPlatformType,
  PlatformDetailsResponseType,
  PlatformDetailsType,
  QueryType,
} from 'src/types';

import { API } from './index';
import { createTrendingPostsFromRawPosts } from '@utils/common.utils';

async function fetchAllPlatforms(
  query: QueryType = {},
): Promise<BlogHomepageCardPlatformType[]> {
  let platformURL = `${process.env.NEXT_PUBLIC_STRAPI_API_URL}/platforms?`;

  const { start = 0, limit = 6, language = 'en' } = query;

  const queryData: Record<string, any> = {
    _sort: 'order:ASC',
    _start: start,
    _limit: limit,
    _locale: language,
  };

  if (query?.listTypeToSkip) {
    queryData['slug_ne'] = query.listTypeToSkip;
  }

  platformURL += qs.stringify(queryData, { encode: false });

  const { data }: AxiosResponse<BlogHomepageCardPlatformType[]> = await API.get(
    platformURL,
  );

  return data.map(
    ({ id, name, description, slug, image, SEO, bannerImage, bgColor }) => {
      return { id, name, description, slug, image, SEO, bannerImage, bgColor };
    },
  );
}

async function fetchTotalPlatformsCount({ language = 'en' }): Promise<number> {
  const { data }: AxiosResponse<number> = await API.get(
    `${process.env.NEXT_PUBLIC_STRAPI_API_URL}/platforms/count?_locale=${language}`,
  );
  return data;
}

async function fetchPlatformDetails(
  slug: string,
  language = 'en',
): Promise<PlatformDetailsType> {
  let platformURL = `${process.env.NEXT_PUBLIC_STRAPI_API_URL}/platforms/${slug}?_locale=${language}`;

  const { data }: AxiosResponse<PlatformDetailsResponseType> = await API.get(
    platformURL,
  );

  return {
    id: data.id,
    name: data.name,
    description: data.description,
    image: data.image,
    slug,
    trendingPosts: createTrendingPostsFromRawPosts(data.trendingPosts),
    bannerImage: data.bannerImage,
    SEO: data.SEO,
    bgColor: data.bgColor,
  };
}

export { fetchAllPlatforms, fetchTotalPlatformsCount, fetchPlatformDetails };
